import { financeOperatorsApi } from 'entities/financeOperations/model';
import { HTTP_METHODS } from 'shared/consts';
import { IReasonItem } from 'entities/financeOperations/types';

type GetReasonByIdParamsType = {
  id: number;
};

const getFinanceOperatorReasonApi = financeOperatorsApi.injectEndpoints({
  endpoints: (builder) => ({
    getReasons: builder.query<IReasonItem[], null>({
      query: () => ({
        url: '/wallet/admin/dicts/reasons/',
        method: HTTP_METHODS.GET,
      }),
      providesTags: ['FinanceOperationId'],
    }),
    getReasonById: builder.query<IReasonItem, GetReasonByIdParamsType>({
      query: ({ id }) => ({
        url: `/wallet/admin/dicts/reasons/${id}/`,
        method: HTTP_METHODS.GET,
      }),
    }),
  }),
});

export const { useGetReasonsQuery, useGetReasonByIdQuery } = getFinanceOperatorReasonApi;
